import { WprLogLevel } from './error/WprErrorInfo';

/**
 * フレームワーク設定情報
 */
export class WprSettingInfo {
	// public 変数	-----------------------------------------------------------
	private m_LogLevel: WprLogLevel					= WprLogLevel.WARNING;		// 出力ログレベル
	// private m_DefaultDialogConfig: MatDialogConfig	= undefined;				// ダイアログ定義情報
	// ------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** 出力ログレベル */
	public get logLevel(): WprLogLevel 					{ return this.m_LogLevel; 				}	public set logLevel(level: WprLogLevel) 				{ this.m_LogLevel = level;				}
	/** ダイアログ定義情報 */
	// public get defaultDialogConfig(): MatDialogConfig	{ return this.m_DefaultDialogConfig; 	}	public set defaultDialogConfig(config: MatDialogConfig) { this.m_DefaultDialogConfig = config;	}
	// --------------------------------------------------------------------------
}